import { inject, unref } from 'vue';

export function usePiniaManager() {

    const $event = inject('$event');

    /**
     * Checks if a value is invalidated based on its dirty state, last loaded timestamp, and time-to-live (TTL) duration.
     *
     * @param {Ref|boolean} isDirty
     * @param {Ref|number|null} loadedAt
     * @param {number} [ttlMinutes=5]
     * @returns {boolean}
     */
    function isInvalidated(isDirty, loadedAt, ttlMinutes = 5) {
        isDirty = unref(isDirty);
        loadedAt = unref(loadedAt);
        return isDirty || !loadedAt || ((Date.now() - loadedAt) / 1000) / 60 >= ttlMinutes;
    }

    function emitSessionTerminated() {
        $event.dispatchEvent(new Event('session:terminated'));
    }

    function onSessionTerminated(callback) {
        $event.addEventListener('session:terminated', () => {
            if (!callback || typeof callback !== 'function') {
                return;
            }
            return callback();
        });
    }

    return {
        isInvalidated,
        emitSessionTerminated,
        onSessionTerminated
    };
}
